import CustomButton from '../../../common/components/CustomButton';
import PopupContainer from '../../../common/components/PopupContainer';
import CurrencyUtility from '../../../common/utility/CurrencyUtility';

export default function KaraokeModificationFormConfirmWithFeeBeforeDistributionPopup({
  onClose,
  onBack,
  onNext,
  modificationFeeAmount,
} : {
  onClose: () => void,
  onBack: () => void,
  onNext: () => void,
  modificationFeeAmount: number,
}) {
  return (
    <PopupContainer title="確認事項" onClose={() => onClose()}>
      {`この曲はすでに制作に入っているため、1回の修正依頼につき手数料${CurrencyUtility.format(modificationFeeAmount)}円が発生します。`}
      <br />
      1回の修正依頼で3箇所まで修正できます。
      <br />
      <br />
      修正可能な箇所は以下です。
      <br />
      <br />
      ・アーティスト名
      <br />
      ・作詞者
      <br />
      ・作曲者
      <br />
      ・曲名
      <br />
      ・申込者名
      <br />
      ・歌詞
      <br />
      ・音源
      <br />
      ・映像
      <br />
      <br />
      <a href="/contact?karaoke_modify_form">上記以外を修正したい場合はこちらからお問い合わせください。​</a>
      <br />
      <br />
      <form>
        <div className="form__data">
          <ul>
            <li className="bt">
              <CustomButton type="cancel-split" onClick={() => onBack()}>ホームに戻る</CustomButton>
              <CustomButton type="default-split" onClick={() => onNext()}>修正内容の入力へ</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </PopupContainer>
  );
}
